<template>
  <div v-if="agrupacion" class="overflow-hidden">
    <div class="info-viaje-grupo">
      <template v-for="block in sortedBlocks" :key="block.id">
        <component
          :is="getBlockComponent(block.tipo, dispositivo, ENTITY_TYPES.AGRUPACION)"
          :agrupacion="agrupacion"
          :block="block" />
      </template>
    </div>

    <GruposListaEsperaModal
      v-if="showListaEsperaModal"
      :viaje-id="agrupacion.id"
      @close="showListaEsperaModal = false" />
  </div>
</template>

<script setup>
  import { ref, computed, onUnmounted, onBeforeMount } from 'vue';
  import { useRoute } from 'vue-router';
  import { useAgrupacionesStore } from '@/store_pinia/agrupaciones';
  import GruposListaEsperaModal from '@/components/modales/GruposListaEsperaModal.vue';
  import { saveComercialId } from '@/helpers/viajesGrupos';
  import AgrupacionesApiService from '@/services/api/skiandnight/AgrupacionesApiService';
  import { getBlockComponent, sortBlocksByOrder } from '@/helpers/builderBlocksUtils';
  import { DISPOSITIVO, ENTITY_TYPES } from '@/helpers/builderBlocksUtils';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import metaPixelUtils from '@/services/utils/metaPixelUtils';
  import gtagPixelUtils from '@/services/utils/gtagPixelUtils';
  import { useLoadingStore } from '@/store_pinia/loadingStore';

  const agrupacionesStore = useAgrupacionesStore();
  const agenciaStore = agenciaStoreModule();
  const loadingStore = useLoadingStore();

  const route = useRoute();

  const agrupacion = ref(null);
  const showListaEsperaModal = ref(false);
  const builderBlocks = ref([]);
  const uri = route.params.uri;
  const codigoAgrupacion = route.query.codigo;
  const codigoPrevisualizacion = route.query.codigoPrevisualizacion;

  const dispositivo = computed(() => {
    return window.innerWidth < 768 ? DISPOSITIVO.MOBILE : DISPOSITIVO.DESKTOP;
  });

  const sortedBlocks = computed(() => {
    return sortBlocksByOrder(builderBlocks.value);
  });

  function handleResize() {
    dispositivo.value = window.innerWidth < 768 ? DISPOSITIVO.MOBILE : DISPOSITIVO.DESKTOP;
  }

  async function loadAgrupacion() {
    try {
      loadingStore.show();
      agrupacion.value = await agrupacionesStore.fetchAgrupacion(uri, codigoAgrupacion, codigoPrevisualizacion);
      sendViewContentEvent();
    } catch (error) {
      console.error('Error al cargar la agrupación:', error);
    } finally {
      loadingStore.hide();
    }
  }

  async function loadBuilderBlocks() {
    try {
      loadingStore.show();
      builderBlocks.value = await AgrupacionesApiService.getAgrupacionBuilderModule(
        uri,
        codigoAgrupacion,
        codigoPrevisualizacion
      );
    } catch (error) {
      console.error('Error al cargar los bloques del builder:', error);
    } finally {
      loadingStore.hide();
    }
  }

  function sendViewContentEvent() {
    if (agrupacion.value && agrupacion.value.id) {
      metaPixelUtils.sendViewContentEvent(
        agrupacion.value.id,
        agenciaStore.getCurrencyName,
        agrupacion.value.precioDesde || 0
      );
      gtagPixelUtils.sendViewItemEvent(
        agrupacion.value.id,
        agenciaStore.getCurrencyName,
        agrupacion.value.precioDesde || 0
      );
    }
  }

  async function init() {
    try {
      loadingStore.show();
      await saveComercialId(route.query.comercialId);
      await loadAgrupacion();
      await loadBuilderBlocks();
    } catch (error) {
      console.error(error);
    } finally {
      loadingStore.hide();
    }
  }

  onBeforeMount(async () => {
    await init();
    window.addEventListener('resize', handleResize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
  });
</script>

<style scoped lang="scss">
  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
  }

  .info-viaje-grupo {
    margin: 0 auto;
    top: 100px;
    position: relative;
    margin-bottom: 130px;

    @media (max-width: 768px) {
      padding: 0;
      top: 78px;
    }
  }
</style>
